import { useEffect, useRef, useState } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import { useCurrentUserQuery } from 'generated/graphql'
import ChannelDeactivatedModal from '@app.components/modals/ChannelDeactivatedModal'
import ChannelUnavailableModal from '@app.components/modals/ChannelUnavailableModal'
import { mobileBreakPoint } from 'app.styled/media'
import { LINKAREER_BIZ_BASE_URL } from 'utils/config'

// TODO: sticky module화

type TProps = {
  className?: string
  content?: string
  sticky?: boolean
}

const ChannelOwnerCard: React.FC<TProps> = ({
  sticky = false,
  content,
  className,
}) => {
  const [stucked, setStucked] = useState(false)
  const targetRef = useRef<HTMLDivElement | null>(null)
  const [unavailableModalVisible, setUnavailableModalVisible] = useState(false)
  const [deactivatedModalVisible, setDeactivatedModalVisible] = useState(false)

  const { data } = useCurrentUserQuery()

  const handleClickRegist = () => {
    if (!data?.currentUser?.channel) {
      setUnavailableModalVisible(true)
    } else if (data?.currentUser?.channel.deactivatedAt) {
      setDeactivatedModalVisible(true)
    } else {
      window.open(`https://${LINKAREER_BIZ_BASE_URL}/channel`)
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.intersectionRatio < 1) {
          setStucked(true)
        } else {
          setStucked(false)
        }
      },
      { threshold: [1] },
    )
    if (sticky && targetRef.current) {
      observer.observe(targetRef.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [sticky, targetRef])

  return (
    <StyledWrapper
      className={className}
      ref={targetRef}
      data-sticky={sticky}
      data-stucked={stucked}
    >
      <div className="mobile-card">
        <div className="owner-banner-message">
          {content || '내 채널 관리는 PC에서 이용 가능합니다.'}
        </div>
      </div>
      <div className="desktop-card">
        <div>
          <img src="/static/images/channel/banner_notice.png" alt="소식 등록" />
        </div>
        <div className="owner-banner-message">
          {content ||
            '소식을 등록하고 회원들과 교류하면, 지원자를 더 많이 늘릴 수 있습니다.'}
        </div>
        <div className="owner-banner-btn" onClick={handleClickRegist}>
          소식 등록하러 가기
        </div>
      </div>
      <ChannelUnavailableModal
        open={unavailableModalVisible}
        onClose={() => setUnavailableModalVisible(false)}
      />
      <ChannelDeactivatedModal
        open={deactivatedModalVisible}
        onClose={() => setDeactivatedModalVisible(false)}
      />
    </StyledWrapper>
  )
}

export default ChannelOwnerCard

const StyledWrapper = styled.div`
  z-index: 1;
  &[data-sticky='true'] {
    position: sticky;
    top: -1px;
  }
  .desktop-card {
    height: 50px;
    background-color: #003056;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    border-radius: 5px;
    margin-bottom: 16px;
    img {
      width: 35px;
    }
    .owner-banner-message {
      font-size: 18px;
      font-weight: 500;
      z-index: 2;
      line-height: 1.33;
      letter-spacing: -0.72px;
      margin: 0 20px 0 8px;
    }
    .owner-banner-btn {
      background-color: white;
      border-radius: 40px;
      color: #003056;
      font-size: 14px;
      font-weight: bold;
      padding: 6px 16px;
      cursor: pointer;
    }
  }
  .mobile-card {
    display: none;
    height: 40px;
    justify-content: center;
    align-items: center;
    background-color: #003056;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.71;
    letter-spacing: -0.56px;
  }
  ${mobileBreakPoint} {
    .desktop-card {
      display: none;
    }
    .mobile-card {
      display: flex;
    }
  }
`
